module.exports = __webpack_public_path__ + "static/our-story-02482ef3be3001e4a94025b4260a8b98.svg";